<template lang="pug">
  e-svg-icon(:name="item.notify ? 'notification-filled' : 'notification-crossed-outline'")
</template>

<script>
export default {
  name: 'EOrganizationUserNotificationsStatusIcon',
  props: {
    item: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped lang="scss"></style>
